import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customCurrency',
})
export class CustomCurrencyPipe implements PipeTransform {
  transform(value: number, currencyCode: string): string {
    const numericValue = Number(value);

    if (isNaN(numericValue)) {
      // Handle the case where value is not a number
      return 'N/A';
    }
    const stringValue = numericValue.toFixed(2);

    // Split the string into parts for thousands and decimals
    const [thousands, decimals] = stringValue.split('.');

    // Format the thousands part with periods as separators
    const formattedThousands = thousands.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    // Combine the thousands part and decimals with a comma separator
    const formattedValue = `${currencyCode} ${formattedThousands},${decimals}`;
    return formattedValue;
  }
}
